module.exports = __webpack_public_path__ + "static/media/dashboard-marketplace-category4.73f57062.svg";